import * as TYPES from './types';
export default {
    [TYPES.SET_LISTING](payload = []) {
        this.listing = [...payload];
    },
    [TYPES.SET_SLIDER_BTNS](isShow) {
        this.showSliderBtns = isShow;
    },
};
